import {
  isTaskLogDateField,
  isTaskLogDateValue,
  taskLogFieldTranslationKey,
} from 'src/app/task-user/functions/task-log-change.helpers';

export function maintenanceJobLogFieldTranslationKey(fieldName: string): string {
  if (fieldName === 'NextServiceDate') {
    return 'expiryDate';
  }

  return taskLogFieldTranslationKey(fieldName);
}

export function isMaintenanceJobLogDateChange(
  fieldName: string,
  value: string | null | undefined
): boolean {
  return isTaskLogDateField(fieldName) || isTaskLogDateValue(value);
}
